import { createMachine } from 'common/fsm/createMachine';
import { IProcedure, ProcedureState } from './Procedure';
import { ProcedureLogic } from './ProcedureLogic';

/**
 * FSM per le domande
 */
export const ProcedureMachine = createMachine({
  states: Object.values(ProcedureState),
  getState: (procedure: IProcedure) => ProcedureLogic.getState(procedure),
  actions: [
    'edit',
    'edit.activedAt',
    'extend.expiresAt',
    'citizen.view',
    'citizen.send',
    'delete'
  ],
  permissions: {
    [ProcedureState.Draft]: ['edit', 'delete'],
    [ProcedureState.Ready]: [
      'edit.activedAt',
      'extend.expiresAt',
      'citizen.view',
      'delete'
    ],
    [ProcedureState.Published]: [
      'edit.activedAt',
      'extend.expiresAt',
      'citizen.view'
    ],
    [ProcedureState.Active]: [
      'extend.expiresAt',
      'citizen.view',
      'citizen.send'
    ],
    // Non modificabili
    [ProcedureState.Canceled]: ['delete'], // TODO Controllare
    [ProcedureState.Expired]: ['citizen.view', 'extend.expiresAt'],
    [ProcedureState.Suspended]: ['citizen.view'],
    [ProcedureState.Test]: ['citizen.view', 'citizen.send', 'edit'],
    [ProcedureState.Evaluating]: ['citizen.view', 'extend.expiresAt']
  },
  transitions: [
    // Pubblicazione
    { from: ProcedureState.Draft, to: ProcedureState.Published },
    { from: ProcedureState.Draft, to: ProcedureState.Canceled },
    { from: ProcedureState.Draft, to: ProcedureState.Test },
    // Riporta in bozza
    { from: ProcedureState.Ready, to: ProcedureState.Draft },
    { from: ProcedureState.Active, to: ProcedureState.Draft }, // TODO/HI Eliminare in produzione
    { from: ProcedureState.Published, to: ProcedureState.Draft }, // TODO/HI Eliminare in produzione
    { from: ProcedureState.Evaluating, to: ProcedureState.Draft }, // TODO/HI Eliminare in produzione
    // Sospensione
    { from: ProcedureState.Ready, to: ProcedureState.Suspended },
    { from: ProcedureState.Active, to: ProcedureState.Suspended },
    { from: ProcedureState.Published, to: ProcedureState.Suspended },
    { from: ProcedureState.Evaluating, to: ProcedureState.Suspended },
    // Annullamento
    { from: ProcedureState.Ready, to: ProcedureState.Canceled },
    { from: ProcedureState.Active, to: ProcedureState.Canceled },
    { from: ProcedureState.Published, to: ProcedureState.Canceled },
    { from: ProcedureState.Suspended, to: ProcedureState.Canceled },
    { from: ProcedureState.Evaluating, to: ProcedureState.Canceled },
    // Riattivazione da sospensione
    { from: ProcedureState.Suspended, to: ProcedureState.Ready },
    // Terminare i test
    { from: ProcedureState.Test, to: ProcedureState.Draft },
    { from: ProcedureState.Test, to: ProcedureState.Published }
  ]
});
